import React from 'react'
import { Loading } from '@splunk-iteng/splunk-shared-components'

import { useOktaUserQuery } from '../../graphql'

export function AppLevel() {
  const { data, loading, error } = useOktaUserQuery({
    variables: { username: 'jgomezhernandez' }
  })

  if (loading) return <Loading />
  if (error) return <p>Error :(</p>
  return (
    <ul>
      {data && (
        <p>
          <pre>{JSON.stringify(data, null, 2)}</pre>
        </p>
      )}
    </ul>
  )
}
